import { Checkbox, Select } from 'antd';
import {
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LineElement,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import moment from 'moment';
import { useEffect, useState } from 'react';
import {
  CartesianGrid,
  Line as Line2,
  LineChart,
  ResponsiveContainer,
  Tooltip as Tooltip2,
  XAxis,
  YAxis,
} from 'recharts';
import { BondEntity } from '../../../../../entities/bond.entity';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

// const MyLineChart = ({ data }: { data: any }) => {
//   return (
//     <LineChart width={680} height={300} data={data}>
//       <XAxis dataKey='date' />
//       <YAxis />

//       <Legend2 />
//       <Line2 type='monotone' dataKey='average' stroke='#8884d8' />
//     </LineChart>
//   );
// };

interface countryState {
  [key: string]: boolean;
}

const sortFn = (
  a: { category: string; value: number },
  b: { category: string; value: number },
) => moment(a.category).valueOf() - moment(b.category).valueOf();
// const countries = ['Came', 'Gab', 'Tcha', 'Centr', 'Cong', 'Eq.'];
const averageData = (data: BondEntity[], pays: string) => {
  // Créer un objet pour stocker les totaux et les comptes
  interface MonObjet {
    [key: string]: string; // Les valeurs peuvent être des chaînes de caractères ou des nombres
  }
  const totals: MonObjet = {};
  const counts: MonObjet = {};

  for (let item of data) {
    if (pays === 'CEMAC' || item.pays === pays) {
      // Utiliser la date comme clé
      const key = moment(item.dateMaturite).format('YYYY-MM');

      // Si la clé n'existe pas encore, l'initialiser
      if (!totals[key]) {
        totals[key] = '0';
        counts[key] = '0';
      }

      // Ajouter le nombre à la somme totale et incrémenter le compteur
      var total = parseFloat(totals[key]);
      total += parseFloat(item.tauxMarginal.toString());
      totals[key] = total.toString();
      var count = parseInt(counts[key]);
      count++;
      counts[key] = count.toString();
    }
  }

  // Créer un nouveau tableau pour les résultats

  let result: { category: string; value: number }[] = [];

  const yearsSet = Array.from(
    new Set(
      data
        .sort(
          (a, b) =>
            moment(a.dateMaturite).valueOf() - moment(b.dateMaturite).valueOf(),
        )
        .map((e) => moment(e.dateMaturite).format('YYYY-MM')),
    ),
  );

  // Calculer la moyenne pour chaque date
  let latest = totals[yearsSet[0]];
  let latest2 = counts[yearsSet[0]];
  for (var k = 0; k < yearsSet.length; k++) {
    if (totals[yearsSet[k]]) {
      latest = totals[yearsSet[k]];
      latest2 = counts[yearsSet[k]];
      result.push({
        category: yearsSet[k],
        value: Number((parseFloat(latest) / parseInt(latest2)).toFixed(2)),
      });
    } else {
      result.push({
        category: yearsSet[k],
        value: Number((parseFloat(latest) / parseInt(latest2)).toFixed(2)),
      });
    }
  }
  result = result.sort(sortFn);
  /*  
   const yearsSet1 = new Set(result.map(e => moment(e.category).format("YYYY-MM")));
 
   Array.from(yearsSet).map(i => {
     if (!Array.from(yearsSet1).includes(i + "")) {
       result.push({
         category: `${i}`,
         value: 0,
       });
       // console.log({result})
     }
   })
  
 
   result = result.sort(
     sortFn
   );
 

 // Calculer la moyenne pour chaque date
 for (const key in totals) {
   result.push({
     category: key,
     value: parseFloat(totals[key]) / parseInt(counts[key]),
   });
 }*/
  // Trier le tableau par date
  const serie = {
    name: pays,
    data: result,
  };

  return serie;
};
export const Courbes = ({
  bondsData,
  getBond,
}: {
  bondsData: BondEntity[];
  getBond: (b: BondEntity, ope: '1' | '2') => void;
}) => {
  //const sortFn = (a: { date: string, average: number }, b: { date: string, average: number }) => (moment(b.date).diff(moment(b.date), "y"))

  const [periodicite, setPeriodicite] = useState(bondsData);
  const [tableau] = useState(averageData(periodicite, 'CEMAC'));
  const [periode, setPeriode] = useState({
    key: '',
    value: 'Historique complet',
  });
  const [visiblestate, setVisible] = useState<countryState>({
    CEMAC: true,
    Cameroun: true,
    Centrafrique: true,
    Congo: true,
    Gabon: true,
    'Guinnee Eq': true,
    Tchad: true,
  });
  //Cameroun
  const [tableau_cmr] = useState(averageData(periodicite, 'Cameroun'));
  const [tableau_cen] = useState(averageData(periodicite, 'Centrafrique'));
  const [tableau_tch] = useState(averageData(periodicite, 'Tchad'));
  const [tableau_ga] = useState(averageData(periodicite, 'Gabon'));
  const [tableau_cg] = useState(averageData(periodicite, 'Congo'));
  const [tableau_geq] = useState(averageData(periodicite, 'Guinée Eq.'));
  const [series, setSeries] = useState([
    tableau_cmr,
    tableau_ga,
    tableau_tch,
    tableau_cen,
    tableau_cg,
    tableau_geq,
    tableau,
  ]);

  useEffect(() => {
    if (periode.key) {
      switch (periode.key) {
        case '3 semaines':
          return setPeriodicite(
            bondsData.filter(
              (e) =>
                moment(e.dateMaturite).diff(moment().add(3, 'weeks'), 'week') <=
                3,
            ),
          );
        case '1 mois':
          return setPeriodicite(
            bondsData.filter(
              (e) =>
                moment(e.dateMaturite).diff(moment().add(1, 'month'), 'month') <
                1,
            ),
          );
        case '6 mois':
          return setPeriodicite(
            bondsData.filter(
              (e) =>
                moment(e.dateMaturite).diff(
                  moment().add(1, 'month'),
                  'months',
                ) <= 6,
            ),
          );
        case '1 an':
          return setPeriodicite(
            bondsData.filter(
              (e) =>
                moment(e.dateMaturite).diff(
                  moment().add(1, 'year'),
                  'months',
                ) <= 12,
            ),
          );
      }
    } else {
      setPeriodicite(bondsData);
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periode]);

  useEffect(() => {
    /*  setCemac(averageData(periodicite, 'CEMAC'));
     SetCmeroun(averageData(periodicite, 'Cameroun'));
     setCentrafrique(averageData(periodicite, 'Centrafrique'));
     setTchad(averageData(periodicite, 'Tchad'));
     setGabon(averageData(periodicite, 'Gabon'));
     setCongo(averageData(periodicite, 'Congo'));
     setGuineeEq(averageData(periodicite, 'Guinée Eq.')); */
    setSeries([
      averageData(periodicite, 'Cameroun'),
      averageData(periodicite, 'Gabon'),
      averageData(periodicite, 'Tchad'),
      averageData(periodicite, 'Centrafrique'),
      averageData(periodicite, 'Congo'),
      averageData(periodicite, 'Guinée Eq'),
      averageData(periodicite, 'CEMAC'),
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periodicite]);

  const handleChange = (e: any) => {
    setVisible((prevState) => ({
      ...prevState,
      [e.target.id]: !prevState[e.target.id],
    }));
  };
  const lineClors: { [cle: string]: string } = {
    Gabon: '#FF3333',
    Cameroun: '#8884d8',
    Congo: '#1ede93',
    Tchad: '#1a73e8',
    'Guinnee Eq': '#f4e809',
    Centrafrique: '#ff7875',
    CEMAC: '#a31545',
  };

  return (
    <ResponsiveContainer width='100%' height='100%'>
      <>
        <LineChart
          width={680}
          height={400}
          margin={{ bottom: 50, top: 20, right: 50 }}
          style={{ position: 'absolute', top: 50 }}
        >
          <CartesianGrid strokeDasharray='0 0 ' />
          <XAxis
            dataKey='category'
            allowDuplicatedCategory={false}
            angle={305}
            textAnchor='end'
            dy={0}
          />
          <YAxis dataKey='value' range={[0, 10]} />
          <Tooltip2 />
          {series
            ?.filter((e) => visiblestate[e.name])
            .map((s, i) => (
              <Line2
                dataKey='value'
                type='monotone'
                data={s.data}
                stroke={lineClors[s.name]}
                strokeWidth={5}
                dot={false}
                name={s.name}
                key={s.name}
              />
            ))}
        </LineChart>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'left',
            position: 'absolute',
            left: 55,
            top: 0,
            color: '#ffffff',
            fontWeight: 'bold',
            width: 'fit-content',
          }}
        >
          <label>Historique</label>{' '}
          <Select
            options={[
              { key: '3 semaines', value: '3 semaines' },
              { key: '1 mois', value: '1 mois' },
              { key: '6 mois', value: '6 mois' },
              { key: '1 an', value: '1 an' },
              { key: '', value: 'Historique complet' },
            ]}
            value={periode}
            onSelect={(key, value) => setPeriode(value)}
            size='middle'
            style={{ width: '100%' }}
          />
        </div>
        {Object.keys(visiblestate).map((country, i) => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              position: 'absolute',
              left: 663,
              top: !i ? 65 : 30 + 40 * (i + 1),
              color: lineClors[country],
              fontWeight: 'bold',
              clear: 'both',
            }}
          >
            <Checkbox
              id={country}
              checked={visiblestate[country]}
              onChange={handleChange}
              style={{ marginRight: 3 }}
            />
            <label style={{ cursor: 'pointer' }} htmlFor={`${country}`}>
              {country}
            </label>{' '}
          </div>
        ))}
      </>
    </ResponsiveContainer>
  );
};
